import * as store from '@daas-consulting/core-frontend-store';
import * as models from '@daas-consulting/security/authentication/frontend/models';
import { context, feature } from '../authentication.const';
import { NullableType } from './authentication.state-model';

export class Login {
  static readonly type = store.getActionName({
    context,
    feature,
    section: 'auth',
    action: 'login',
  });
  constructor(readonly payload: NullableType<string>) {}
}

export const {
  action: LoginWithCode,
  failure: LoginWithCodeFailure,
  request: LoginWithCodeRequest,
  successful: LoginWithCodeSuccessful,
} = store.getActionsClass<string, models.Token>({
  context,
  feature,
  section: 'auth',
  action: 'login with code',
});

export const {
  action: Generate,
  failure: GenerateFailure,
  request: GenerateRequest,
  successful: GenerateSuccessful,
} = store.getActionsClass<void, string>({
  context,
  feature,
  section: 'auth',
  action: 'generate',
});

export const {
  action: TurnOn,
  failure: TurnOnFailure,
  request: TurnOnRequest,
  successful: TurnOnSuccessful,
} = store.getActionsClass<models.TurnOn, void>({
  context,
  feature,
  section: 'auth',
  action: 'turn on',
});

export const {
  action: Validate2fa,
  failure: Validate2faFailure,
  request: Validate2faRequest,
  successful: Validate2faSuccessful,
} = store.getActionsClass<models.Authenticte, models.Token>({
  context,
  feature,
  section: 'auth',
  action: 'validate 2fa',
});

export class Logout {
  static readonly type = store.getActionName({
    context,
    feature,
    section: 'auth',
    action: 'logout',
  });
}

export class GotoGenerateQrCode {
  static readonly type = store.getActionName({
    context,
    feature,
    section: 'auth',
    action: 'goto generate qr code',
  });
}

export class GotoTurnOn {
  static readonly type = store.getActionName({
    context,
    feature,
    section: 'auth',
    action: 'goto turn on',
  });
}
